import React, { useState, useCallback, useEffect } from 'react'
import { Modal, LegacyCard, TextField } from '@shopify/polaris'
import BookingActions from 'Redux/BookingRedux'
import { useDispatch, useSelector } from 'react-redux'
import i18n from '../../translations/i18n'

function EditCustomerPaymentModal(props) {
  const { t } = i18n
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const sendEmail = () => {
    setLoading(true)
    dispatch(
      BookingActions.updateCustomerPaymentMethod(
        { subscription_contract_id: props.uuid },
        () => {
          setLoading(false)
          props.handleClose()
        }
      )
    )
  }

  return (
    <div>
      <Modal
        open={props.showModal}
        onClose={props.handleClose}
        title={t('update-payment-method')}
        primaryAction={{
          content: t('send-email'),
          primary: true,
          onAction: sendEmail,
          loading: loading,
        }}
      >
        <div style={{ padding: 20 }}>{t('email-sent-to-update-customer')}</div>
      </Modal>
    </div>
  )
}

export default EditCustomerPaymentModal
